import * as React from 'react';

function IconActionSearchLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M22.4533 19.7867C23.4631 18.2702 24.0012 16.4886 24 14.6667C24.0027 12.5895 23.3125 10.5707 22.0385 8.93C20.7644 7.28933 18.9795 6.12055 16.9663 5.60874C14.9531 5.09692 12.8267 5.27132 10.9238 6.10433C9.02095 6.93733 7.45032 8.38133 6.46067 10.2077C5.47102 12.034 5.1189 14.1383 5.46008 16.1873C5.80126 18.2363 6.81623 20.113 8.34428 21.5201C9.87233 22.9272 11.8261 23.7843 13.8963 23.9558C15.9664 24.1273 18.0346 23.6032 19.7733 22.4667L24 26.6667L26.6667 24L22.4533 19.7867ZM7.99999 14.6667C7.99999 13.3482 8.39098 12.0592 9.12352 10.9629C9.85606 9.86656 10.8973 9.01208 12.1154 8.5075C13.3336 8.00291 14.674 7.87089 15.9673 8.12813C17.2605 8.38536 18.4483 9.0203 19.3807 9.95265C20.313 10.885 20.948 12.0729 21.2052 13.3661C21.4625 14.6593 21.3304 15.9997 20.8258 17.2179C20.3213 18.4361 19.4668 19.4773 18.3705 20.2098C17.2741 20.9424 15.9852 21.3334 14.6667 21.3334C12.8985 21.3334 11.2028 20.631 9.95261 19.3807C8.70236 18.1305 7.99999 16.4348 7.99999 14.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionSearchLarge;
